module.exports = __webpack_public_path__ + "img/u253.6e915b1a.jpg";